import { useDroppable } from "@dnd-kit/core";

import { useDragDrop } from "@/components/UnifiedRegistry/DragAndDrop/DragDropProvider";
import { cn } from "@/lib/utils";

interface TrailingDropZoneProps {
  parentFolderId: number | null;
}

export const TrailingDropZone = ({ parentFolderId }: TrailingDropZoneProps) => {
  const { activeItem, draggedOverFolderId } = useDragDrop();
  const { isOver, setNodeRef } = useDroppable({
    id: "parent-area-trailing",
    data: { type: "parent-area", parentFolderId },
  });

  const resolved = parentFolderId === null ? -1 : parentFolderId;
  const isDragging = !!activeItem;
  const isRootContext = parentFolderId === null;
  const isRootHovered = isDragging && draggedOverFolderId === -1;
  const isDropActive = isDragging && isOver && draggedOverFolderId === resolved;

  const showRootDropArea = isRootContext && isDragging;
  const showParentDropArea = !isRootContext && isDropActive;
  const isHighlighted = isDropActive || (isRootContext && isRootHovered);

  return (
    <div
      ref={setNodeRef}
      className={cn(
        "flex-1 rounded-md transition-all duration-200",
        (showRootDropArea || showParentDropArea) && "min-h-[40px]",
        isHighlighted && "bg-blue-500/10 ring-1 ring-blue-200",
      )}
    />
  );
};
